import { h } from './index-16457198.js';
import { c as clsx } from './clsx.m-3c237499.js';
import { A as ARIA } from './constants-dbaf23dd.js';

const InternalNesCheckboxInput = ({ id, name, value, checked, disabled, required, isIndeterminate, tabIndex, helpText, label, hiddenLabel, loading, border, error, padding, onClick, dataAttributes, }) => (h("div", { class: clsx("nes-checkbox", {
    "nes-checkbox--checked": checked,
    "nes-checkbox--disabled": disabled,
    "nes-checkbox--indeterminate": isIndeterminate && !checked,
    "nes-checkbox--is-loading": loading,
    "nes-checkbox--padding": padding,
    "nes-checkbox--borderless": !border,
  }), onClick: onClick },
  h("div", { class: clsx("nes-checkbox__input-holder", {
      "nes-checkbox__input-holder--checked": checked,
      "nes-checkbox__input-holder--indeterminate": isIndeterminate,
      "nes-checkbox__input-holder--borderless": !border,
      "nes-checkbox__input-holder--error": error,
    }), "data-test-id": "nes-checkbox-input-holder" },
    h("div", { class: clsx("nes-checkbox__icon", {
        "is-active": checked,
      }) },
      h("nes-icon", { color: "text-light", name: "check-thick", "nes-aria-hidden": "true" })),
    h("div", { class: clsx("nes-checkbox__icon", "nes-checkbox__icon--indeterminate", {
        "is-active": isIndeterminate && !checked,
      }) },
      h("div", { class: "nes-checkbox__iconIndeterminate" })),
    h("input", { class: "nes-checkbox__input", type: "checkbox", id: id, name: name, value: value, checked: checked, disabled: disabled, required: required, "aria-describedby": helpText ? ARIA.helpText : null, tabIndex: tabIndex ? tabIndex : undefined, "data-nes": dataAttributes })),
  h("div", { class: "nes-checkbox__text" },
    h("label", { htmlFor: id, class: clsx("nes-checkbox__label", {
        "nes-sr-only": hiddenLabel,
      }) }, label),
    helpText && (h("div", { class: "nes-checkbox__help-text" },
      h("nes-help-text", { id: ARIA.helpText }, helpText))))));

export { InternalNesCheckboxInput as I };
